import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {getEventTemplateSchedulerPreview} from '../../../../Store/Actions';
import EventTemplateSchedulerPreviewComponent from '../../../../Components/AdminComponents/EventTemplateScheduler/EventTemplateSchedulerPreview';

const EventTemplateSchedulerPreviewContainer = () => {
  const {eventId, schedulerId} = useParams();
  const dispatch = useDispatch();
  const {loading, error} = useSelector(({common}) => common);
  const {eventTemplateSchedulerPreview} = useSelector(
    ({eventTemplateSchedulers}) => eventTemplateSchedulers,
  );

  useEffect(() => {
    dispatch(getEventTemplateSchedulerPreview(eventId, schedulerId));
  }, [dispatch, eventId, schedulerId]);

  const emailTemplateBody = eventTemplateSchedulerPreview?.data;

  return (
    <EventTemplateSchedulerPreviewComponent
      emailTemplateBody={emailTemplateBody}
      loading={loading}
      error={error}
    />
  );
};

export default EventTemplateSchedulerPreviewContainer;
